import { render } from "./StudentPassLimitsTable.vue?vue&type=template&id=ea1bd000"
import script from "./StudentPassLimitsTable.vue?vue&type=script&lang=js"
export * from "./StudentPassLimitsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__